<template>
  <sui-page>
    <sui-page-header :pageId="this.$options.name" />
    <sui-page-contents>
      <div class="comm_view_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_TITLE')"
              :vertical="false"
              required
            />
          </div>
          <div class="col-xs-7">
            <sui-text-field
              v-model="frame0.boardTitle"
              placeholder
              :disabled="false"
              max-length="100"
              :readonly="false"
            />
          </div>
          <div
            v-if="isCategoryGroupExist"
            class="col-xs-1"
          >
            <sui-input-label
              :label="$t('MSG_TXT_CATG')"
              :vertical="false"
            />
          </div>
          <div
            v-if="isCategoryGroupExist"
            class="col-xs-3"
          >
            <sui-select-box
              v-model="frame0.selectData"
              :option-list="categoryOptions"
              placeholder="select"
            />
          </div>
        </div>
      </div>
      <div class="mrB10" />
      <sui-web-editor
        ref="tuiEditor"
        v-model="frame0.editorContent"
      />
      <div class="mrB10" />
      <cmp-file-attacher
        ref="fileAttacher"
        :pageId="this.$options.name"
        :attachDocumentId="attachDocumentId"
        :attachGroupId="'ATG_CLB_BBS_COMMON'"
        :customAttachRestrictionSize="attachRestrictSize"
      />
      <div class="comm_btn_wrap">
        <sui-button
          type="button"
          class="comm_btn_border"
          @click="onCancel()"
        >
          {{ $t('MSG_BTN_CANCEL') }}
        </sui-button>
        <sui-button
          v-permission:create="contextPageId"
          type="button"
          class="comm_btn_border"
          @click="validateSaveData('tempRegister')"
        >
          {{ $t('MSG_BTN_TMP_SAVE') }}
        </sui-button>
        <sui-button
          v-permission:create="contextPageId"
          type="button"
          class="comm_btn_solid"
          @click="validateSaveData('register')"
        >
          {{ $t('MSG_BTN_RGST') }}
        </sui-button>
      </div>
    </sui-page-contents>
    <sui-page-footer />
  </sui-page>
</template>

<script>
import BasePage from '~cm/components/BasePage';

export default {
  name: 'PGE_CLB_00021', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  props: {
    closePagePopup: {
      type: Function,
    },
    pageInitialData: {
      type: Object,
    },
  },
  data() {
    return {
      attachGroupId: '',
      bbsId: '',
      attachDocumentId: '',
      categoryOptions: [],
      fileList: [],
      frame0: {
        selectData: {
          label: '',
          key: '',
        },
        boardTitle: '',
        boardName: '',
        notice: false,
        editorContent: '',
      },
      applicationUserId: this.$store.getters.userInfo.userName,
      functionType: '',
    };
  },
  computed: {},
  watch: {
    frame0(val) {
      this.frame0 = val;
    },
  },
  datasets: [],
  beforeMount() {
    this.bbsId = this.pageInitialData.bbsId;
    this.isCategoryGroupExist = this.pageInitialData.isCategoryGroupExist;
    this.attachRestrictSize = this.pageInitialData.attachRestrictSize;
    this.tbabRestrictSize = this.pageInitialData.tbabRestrictSize;
    if (!utils.isEmpty(this.pageInitialData.objTemplate.templateId)) {
      this.loadData();
    }
    this.categoryItems();
    this.frame0.boardName = this.pageInitialData.bbsName;
  },
  mounted() {},
  methods: {
    categoryItems() {
      http
        .request('PGE_CLB_00003', 'DTS_CLB_00050', {
          path: {
            'bulletin-board-id': this.bbsId,
          },
        })
        .then(res => {
          if (res.data) {
            const optionList = res.data;
            let i;
            for (i = 0; i < optionList.length; i++) {
              optionList[i].label = optionList[i].bbsCatgItemNm;
              optionList[i].key = optionList[i].bbsCatgItemId;
              delete optionList[i].bbsCatgItemId;
              delete optionList[i].bbsCatgItemNm;
              this.categoryOptions = optionList;
            }
          }
        });
    },
    loadData() {
      if (!utils.isEmpty(this.pageInitialData.objTemplate)) {
        const { objTemplate } = this.pageInitialData;
        this.selectTemplate(objTemplate);
      }
    },
    selectTemplate(objTemplate) {
      // if (objTemplate !== undefined) return;
      http.request(this.$options.name, 'DTS_CMZ_00075', {
        path: {
          'template-id': objTemplate.templateId,
        },
        data: objTemplate,
      }).then(res => {
        // set WebEditorContents
        if (utils.isEmpty(res.data.sendTmpltCntn) === false) {
          this.isWebEditorContentsHtml = true;
          let tempContent = '';
          if (utils.isEmpty(this.pageInitialData.mailContents) === false) {
            tempContent = `${this.pageInitialData.mailContents}\r\n`
              + `<br><br>\r\n${
                res.data.sendTmpltCntn}`;
          } else {
            tempContent = res.data.sendTmpltCntn;
          }
          if (utils.isEqual(this.pageInitialData.Editor, 'Y') === true) {
            // this.$refs.tuiEditor.setHtml(tempContent);
            this.$refs.tuiEditor.setContent(tempContent);
          } else {
            this.$refs.tuiViewer.editorViewer.setHtml(tempContent);
          }
        } else if (utils.isEmpty(this.pageInitialData.mailContents) === false) {
          if (utils.isEqual(this.pageInitialData.Editor, 'Y') === true) {
            this.$refs.tuiEditor.setContent(this.pageInitialData.mailContents);
          } else {
            this.$refs.tuiViewer.editorViewer.setValue(this.pageInitialData.mailContents);
          }
        }
      }).catch(error => {
        console.log(error);
      });
    },
    // Reset attachment
    onResetFileAttacher() {
      this.$refs.fileAttacher.reset();
    },

    // File Info
    onClickSeachByAttachmentId() {
      if (this.attachDocumentId) {
        this.fileList = this.$refs.fileAttacher.searchAttachedFileInfoByDocId(
          this.attachDocumentId,
        );
      }
    },

    /* Get attachment id first */
    getAttachDocumentId() {
      const pathParams = {
        'bulletin-board-id': this.bbsId,
      };
      http
        .request('PGE_CLB_00021', 'DTS_CLB_00007', {
          path: pathParams,
        })
        .then(res => {
          this.attachDocumentId = res.data.atthDocId;
        });
    },

    // Get the file info (List of Files)
    getFileListInfo() {
      this.fileList = this.$refs.fileAttacher.getAttachGroupItemListInfo();
    },

    // Validate Announcement before registration
    /* TODO : Update with messageID */
    validateSaveData(type) {
      this.frame0.editorContent = this.$refs.tuiEditor.getHtml();
      this.functionType = type;
      this.getFileListInfo();
      if (!this.frame0.boardTitle) {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_INPUT_CELL'), this.$t('MSG_TXT_TITLE')), null, null);
        return false;
      }
      if (this.isCategoryGroupExist && !this.frame0.selectData.key) {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_INPUT_CELL'), this.$t('MSG_TXT_CATG')), null, null);
        return false;
      }
      if (!this.frame0.editorContent || this.$refs.tuiEditor.getText().trim().length === 0) {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_INPUT_CELL'), this.$t('MSG_TXT_CNTN')), null, null);
        return false;
      }
      if (!this.checkContentSize()) {
        const msg = utils.strFormat(this.$t('MSG_ALT_SIZE_LIMIT_EXCEEDED'), this.tbabRestrictSize);
        utils.messageBox('warning', msg);
        return false;
      }
      if (type === 'register') {
        utils.messageBox('confirm', this.$t('MSG_ALT_RGST'), null, this.saveQNA);
      } else {
        utils.messageBox('confirm', this.$t('MSG_ALT_PRSS_TMP_SAVE'), null, this.tempSaveQNA);
      }
    },
    saveQNA() {
      const dataParams = {
        qnaStateCode: 'P',
        bbsId: this.pageInitialData.bbsId,
        bbsCategoryItemId: this.frame0.selectData.key,
        qnaNoticeObjTextContent: this.frame0.editorContent,
        qnaNoticeObjTextTitle: this.frame0.boardTitle,
        bbsLogDeptId: this.$store.getters.userInfo.departmentId,
        attachFileList: this.fileList && this.fileList[0].attachFileList ? this.fileList[0].attachFileList : [],
      };
      http.request('PGE_CLB_00021', 'DTS_CLB_00017', {
        data: dataParams,
      }).then(res => {
        if (res.data.resultCode) {
          utils.messageBox('information', this.$t('MSG_TXT_REG_OK'), null, null);
          this.closePagePopup(true);
        }
      }).catch(error => {
        console.log(error);
      });
    },
    tempSaveQNA() {
      const dataParams = {
        qnaStateCode: 'D',
        bbsId: this.pageInitialData.bbsId,
        bbsCategoryItemId: this.frame0.selectData.key,
        qnaNoticeObjTextContent: this.frame0.editorContent,
        qnaNoticeObjTextTitle: this.frame0.boardTitle,
        bbsLogDeptId: this.$store.getters.userInfo.departmentId,
        attachFileList: this.fileList && this.fileList[0].attachFileList ? this.fileList[0].attachFileList : [],
      };
      http.request('PGE_CLB_00021', 'DTS_CLB_00017', {
        data: dataParams,
      }).then(res => {
        if (res.data.resultCode) {
          utils.messageBox('information', this.$t('MSG_ALT_PRGS_OK'), null, null);
          this.closePagePopup(true);
        }
      }).catch(error => {
        console.log(error);
      });
    },
    onCancel() {
      this.closePagePopup(false);
    },
    checkContentSize() {
      return this.tbabRestrictSize >= this.$refs.tuiEditor.getContentSize();
    },
  },
};
</script>
<style scoped>
</style>
